import { motion } from "framer-motion";
import { ShieldCheck, Lock, Trash2 } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { PRIVACY } from "@/lib/site";

const ICONS = { ShieldCheck, Lock, Trash2 };

export const Privacy = () => {
  return (
    <section id="privacy" className="relative py-24 sm:py-32" data-testid="privacy-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <Reveal className="mb-14 max-w-2xl">
          <p className="mb-3 text-xs uppercase tracking-[0.25em] text-[#F0C674]/80">
            Глава 05 — Спокойствие
          </p>
          <h2 className="font-serif text-4xl font-bold text-[#EDE6D3] sm:text-5xl lg:text-6xl">
            Безопасность и <span className="text-gold-gradient">приватность</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {PRIVACY.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <Reveal key={p.title} delay={i * 0.1}>
                <motion.div
                  whileHover={{ y: -6 }}
                  transition={{ type: "spring", stiffness: 300, damping: 20 }}
                  className="flex h-full flex-col rounded-2xl border border-[#D4AF6E]/12 bg-surface p-7"
                  data-testid={`privacy-card-${i}`}
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-[#D4AF6E]/25 bg-[#0B0B1F]">
                    <Icon className="h-6 w-6 text-[#F0C674]" />
                  </span>
                  <h3 className="mt-5 font-serif text-2xl font-semibold text-[#EDE6D3]">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#EDE6D3]/60">{p.text}</p>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
